import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-credit',
  templateUrl: './credit.component.html',
  styleUrls: ['./credit.component.sass']
})
export class CreditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
